import axios from "axios";

const notificationFcmBackend = axios.create({
  baseURL: process.env.REACT_APP_API_NOTIFICATION_URL,
});

export const CancelNotificationClient = ({ requestId, orderNumber }) => {
  notificationFcmBackend
    .post("/api/v1/notification/client/cancel", {
      requestId: Number(requestId),
      orderNumber: Number(orderNumber),
    })
    .catch((error) => {
      console.log(error);
    });
};
